import React from 'react';

function getStatusVariant(overallStatus) {
  if (overallStatus === 'All Systems Operational') return 'up';
  if (overallStatus === 'Scheduled Maintenance') return 'maintenance';
  if (overallStatus.includes('Outage')) return 'down';
  return 'degraded';
}

export default function StatusOverviewCard({ overallStatus }) {
  return (
    <div className={`card status-overview status-overview--${getStatusVariant(overallStatus)}`}>
      <div className="status-overview__inner">
        <div className="status-overview__indicator" />
        <div>
          <h2 className="status-overview__title">{overallStatus}</h2>
          <p className="last-updated">Last updated: {new Date().toLocaleTimeString()}</p>
        </div>
      </div>
    </div>
  );
}
